/**
 * @generated SignedSource<<4d2448cfb9c5e0489c6c1dab2c13e030>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ApprovalStyle = "AUTOMATIC" | "MANUAL" | "%future added value";
export type CapabilityType = "BUILDKITE_PIPELINE" | "GITHUB_ACTIONS_WORKFLOW" | "%future added value";
export type ExecutionStatus = "APPROVAL_TIMEOUT" | "APPROVED" | "FAILED" | "PENDING" | "REJECTED" | "SUCCESS" | "WAITING_APPROVAL" | "%future added value";
export type ProductSurface = "ALERT_RESPONDER" | "CHAT" | "DIGEST" | "UNKNOWN" | "%future added value";
export type CapabilityDetailQuery$variables = {
  capabilityId: any;
};
export type CapabilityDetailQuery$data = {
  readonly node: {
    readonly approvalRate30d?: number;
    readonly approvalStyle?: ApprovalStyle;
    readonly capabilityType?: CapabilityType;
    readonly description?: string;
    readonly executions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly approved: boolean;
          readonly createdAt: any;
          readonly executionTimeMs: number | null | undefined;
          readonly id: any;
          readonly parameters: any;
          readonly productSurface: ProductSurface;
          readonly result: any | null | undefined;
          readonly status: ExecutionStatus;
          readonly updatedAt: any;
        };
      }>;
    };
    readonly id?: any;
    readonly isActive?: boolean;
    readonly name?: string;
    readonly parametersSchema?: any;
    readonly targetConfig?: any;
  } | null | undefined;
};
export type CapabilityDetailQuery = {
  response: CapabilityDetailQuery$data;
  variables: CapabilityDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "capabilityId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "capabilityId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "capabilityType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvalStyle",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetConfig",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parametersSchema",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvalRate30d",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 50
    },
    {
      "kind": "Literal",
      "name": "sortBy",
      "value": "created_at"
    },
    {
      "kind": "Literal",
      "name": "sortOrder",
      "value": "desc"
    }
  ],
  "concreteType": "GraphQLCapabilityExecutionConnection",
  "kind": "LinkedField",
  "name": "executions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLCapabilityExecutionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLCapabilityExecution",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "parameters",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "result",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "approved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productSurface",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "executionTimeMs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "executions(limit:50,sortBy:\"created_at\",sortOrder:\"desc\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CapabilityDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "type": "GraphQLCapability",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CapabilityDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "type": "GraphQLCapability",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a0dabc793864ca874f1520b0c49ef9bc",
    "id": null,
    "metadata": {},
    "name": "CapabilityDetailQuery",
    "operationKind": "query",
    "text": "query CapabilityDetailQuery(\n  $capabilityId: GlobalID!\n) {\n  node(id: $capabilityId) {\n    __typename\n    ... on GraphQLCapability {\n      id\n      name\n      description\n      capabilityType\n      isActive\n      approvalStyle\n      targetConfig\n      parametersSchema\n      approvalRate30d\n      executions(limit: 50, sortBy: \"created_at\", sortOrder: \"desc\") {\n        edges {\n          node {\n            id\n            parameters\n            result\n            status\n            approved\n            productSurface\n            executionTimeMs\n            createdAt\n            updatedAt\n          }\n        }\n      }\n    }\n    __isNode: __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "74b8cac8e0175d0fa9aa4aad7880342d";

export default node;
